import React from 'react';

import { CarouselElement } from '../../../element/carousel-element';
import type { CarouselElementType, ProjectHighlightElementType } from '../../../types';
import { useLuminaSubAgentContext } from '../../lumina-sub-agents-context';
import type { ProjectHighlightsData } from '../../types';
import { getSubAgentData } from '../utils';

export const ProjectHighlights = ({
	isStreaming = false,
}: {
	isStreaming?: boolean;
}): React.JSX.Element | null => {
	const { luminaSubAgentResponse } = useLuminaSubAgentContext();
	const projectHighlights = getSubAgentData(luminaSubAgentResponse, 'PROJECT_HIGHLIGHTS');
	if (!projectHighlights?.data) {
		return null;
	}

	try {
		const projectHighlightsData: ProjectHighlightsData = JSON.parse(projectHighlights.data);
		const projectHighlightsCarouselChildren: ProjectHighlightElementType[] =
			projectHighlightsData.highlights.map((projectHighlight) => ({
				tag: 'project-highlight-card',
				attributes: {
					title: projectHighlight.title,
					content: projectHighlight.content,
				},
			}));

		if (!projectHighlightsCarouselChildren.length) {
			return null;
		}

		const projectHighlightsCarouselComponent: CarouselElementType = {
			tag: 'carousel',
			children: projectHighlightsCarouselChildren,
		};

		return (
			<CarouselElement
				component={projectHighlightsCarouselComponent}
				position="two-rows-bottom"
				showArrows={false}
				isStreaming={isStreaming}
			/>
		);
	} catch {
		return null;
	}
};
